import request from './service/index';  
// University 列表查询
export function UniversitySearch_Api(data){//查询列表
    return request({
        url:'CMS/university/university_list',
        method:'post',
        data:data
    });
}

// University 数量
export function getUniversityCount_Api(){
    return request({
        url:'CMS/university/university_count',
        method:'get'
    })
}

// University 地理位置
export function getUniversityAddress_Api(){
    return request({
        url:'CMS/tools/city_drop_down',
        method:'get'
    })
}

export function deleteUniversities_Api(data){//批量删除
    return request({
        url:'CMS/university/university_list',
        method:'delete',
        data:data
    })
}

export function getUniversities_Api(id){//查询
    return request({
        url:`CMS/university/university_detail?university_id=${id}`,
        method:'get'
    })
}

export function createUniversitiy_Api(data){
    return request({
        url:`/CMS/university/university_detail`,
        method:'post',
        data:data
    });
}

export function deleteUniversity_Api(data){
    return request({
        url:`/CMS/university/university_detail`,
        method:'delete',
        data:data
    });
}

export function updateUniversity_Api(data){
    return request({
        url:`/CMS/university/university_detail`,
        method:'put',
        data:data
    })
}
export function outputUniversity_Api(data){
    return request({
        url:'CMS/university/output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}


// WEBPACK FOOTER //
// ./src/apis/university.api.js